import { Link, ModuleBase } from '@/components';
import { CategoryModel, ModuleBaseModel, ModuleBasePropsModel } from '@/types';

type StubTopicsListModel = ModuleBaseModel<
  {
    topics: CategoryModel[];
  } & ModuleBasePropsModel
>;

const StubTopicsList = (data: StubTopicsListModel) => {
  const {
    props: { topics },
  } = data;

  if (!topics || topics.length === 0) {
    return null;
  }

  return (
    <ModuleBase data={data}>
      <div className="container">
        <div className="flex flex-col gap-4">
          <h3 className="text-h3">Topics</h3>
          <div className="flex flex-wrap gap-3 md:gap-5">
            {topics.map((topic) => {
              const content = (
                <div
                  key={topic.id}
                  className="chip border-from-bg/10 flex min-h-[34px] items-center rounded-full border py-2"
                >
                  <div className="chip-content flex flex-wrap gap-x-3 gap-y-1 px-4 whitespace-nowrap sm:w-min xl:w-auto">
                    {topic.categoryDisplayName}
                  </div>
                </div>
              );
              return topic.landingPageLink ? (
                <Link link={topic.landingPageLink} key={topic.id}>
                  {content}
                </Link>
              ) : (
                content
              );
            })}
          </div>
        </div>
      </div>
    </ModuleBase>
  );
};

export default StubTopicsList;
